<template>
  <div class="search-result">
    <Loader v-if="fakeLoading"></Loader>
    <template v-else>
      <div
        v-if="result.length > 0"
        v-bind:key="item.rentalObjectCode"
        v-for="(item, index) in result"
        class="sokledigt-result-item grid">
        <Object-ListItem
          v-if="searchType == 'apartments'"
          v-bind:object="item"
          v-bind:index="index"
          type="search-apartment"></Object-ListItem>
        <Object-ListItem
          v-if="searchType == 'parkings'"
          v-bind:object="item"
          v-bind:index="index"
          type="search-parking"></Object-ListItem>
        <Object-ListItem
          v-if="searchType == 'premises'"
          v-bind:object="item"
          v-bind:index="index"
          type="search-premise"></Object-ListItem>
        <Object-ListItem
          v-if="searchType == 'studentapartments'"
          v-bind:object="item"
          v-bind:index="index"
          type="search-studentapartments"></Object-ListItem>
      </div>
      <div v-if="result.length == 0" class="text-center">
        <p>Det finns tyvärr inga lediga objekt på den aktuella sökningen</p>
      </div>

      <router-link
        v-if="list.length > to"
        :to="{ name: 'Search', query: { page: nextPage } }"
        class="center btn btn-lg btn-primary"
        v-on:click="moreData()">
        Läs in fler
      </router-link>
    </template>
  </div>
</template>
<script>
import Loader from '@/components/ui/loader';

export default {
  props: {
    page: {
      type: Number,
    },
    size: {
      type: Number,
    },
    list: {
      type: Array,
    },
    searchType: {
      type: String,
    },
    append: {
      type: Boolean,
      default: true,
    },
  },
  components: { Loader },
  data() {
    return {
      fakeLoading: false,
      showBodyLoader: false,
    };
  },
  computed: {
    result() {
      return this.list.slice(this.from, this.to);
    },
    nextPage() {
      if (this.$route.query.page) return Number(this.$route.query.page) + 1;

      return 2;
    },
    from() {
      if (this.append) return 0;

      return (this.page - 1) * this.size;
    },
    to() {
      if (this.append) return this.page * this.size;

      return this.from + this.size;
    },
  },
  watch: {
    /**
     * Sökresultatet renderas om vid ändringar av filters.
     * Men vi fakear en loader här.
     */
    list: {
      handler() {
        this.fakeLoading = true;

        setTimeout(() => {
          this.fakeLoading = false;
        }, 500);
      },

      deep: true,
    },
  },
  methods: {
    moreData() {
      this.$emit('change');
    },
  },
};
</script>
